import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/contracts/${path}`;

// Staff
export function listContractTemplates() {
  return defaultClient.request({ url: URL('templates/') });
}

export function fetchContractTemplate(id) {
  return defaultClient.request({ url: URL(`templates/${id}/`) });
}

export function generateContract(payload = {}) {
  return defaultClient.request({ url: URL('generate/'), method: 'POST', payload });
}

export function sendContract(id, payload = {}) {
  return defaultClient.request({ url: URL(`${id}/send/`), method: 'POST', payload });
}

export function listContracts(clientSlug, parentCompanyId) {
  // client_slug returns client-level AND parent-company contracts;
  // parent_company_id alone would miss contracts attached to the client.
  const params = clientSlug
    ? `?client_slug=${clientSlug}`
    : `?parent_company_id=${parentCompanyId}`;
  return defaultClient.request({ url: URL(params) });
}

// Public (no auth) — signing flow
export function fetchContractForSigning(signToken) {
  return defaultClient.request({ url: URL(`sign/${signToken}/`), auth: false });
}

export function signContract(signToken, payload = {}) {
  return defaultClient.request({ url: URL(`sign/${signToken}/`), method: 'POST', payload, auth: false });
}
